import { Box, Stack, Text } from '@ltvco/refresh-lib/theme';
import React from 'react';

import { SUBSCRIBE_BENEFITS } from '../../constants';
import { SectionCard } from '../components';

import { BenefitRow } from './components';

export const BenefitsSection = () => {
  return (
    <SectionCard sx={{ mt: 3 }}>
      <Box>
        <Stack spacing={1.5}>
          {SUBSCRIBE_BENEFITS.map(
            (item: { icon: React.ReactNode; text: string }, idx: number) => (
              <BenefitRow key={idx}>
                {item.icon}
                <Text variant="body1">
                  {idx === SUBSCRIBE_BENEFITS.length - 1 ? (
                    <>
                      <Text component="span" fontWeight={800}>
                        MULTIPLE
                      </Text>
                      {item.text.replace('MULTIPLE', '')}
                    </>
                  ) : (
                    item.text
                  )}
                </Text>
              </BenefitRow>
            ),
          )}
        </Stack>
      </Box>
    </SectionCard>
  );
};
